// this file is automatically generated by git.version.ts script
export default {
  'AppName': 'admin-portal',
  'version': '4.0.0',
  'commit': '8902462',
  'branch': 'develop'
  ,'forceDomain': null
};